module.exports = __webpack_public_path__ + "img/es.407491b9.svg";